import { CommonUtilsService} from 'util/services';
import { ActionService } from 'phoenix/services/actionService';
import {
	TrackingService,
	ActionRepository
} from 'sharebase/services';
import {
	PermissionType
} from 'phoenix/domain';
import { DeferredPermissionMenuItem } from 'sharebase-app/domain';
import { AclDatastore } from 'sharebase/dataStores/aclDatastore';

export class DeferredPermissionMenuItemFactory {
	static readonly $inject = [
        'utils',
        '$injector',
        '$q',
        'pxActionService',
        'sbTrackingService',
        'sbAclDatastore'
    ];
    constructor(
        private utils:CommonUtilsService, 
        private $injector:ng.auto.IInjectorService,
        private $q:ng.IQService,
        private pxActionService:ActionService,
        private sbTrackingService:TrackingService,
        private sbAclDatastore:AclDatastore,
        private sbActionRepository:ActionRepository
    ){
    }
    
	public create(actionName:string, label:string, icon:string, permissions?:PermissionType) {
        // manually inject action repository to avoid circular dependency
        let sbActionRepository:ActionRepository = this.$injector.get('sbActionRepository');
        let item = new DeferredPermissionMenuItem(
            this.utils, 
            this.$q, 
            this.pxActionService, 
            this.sbTrackingService, 
            this.sbAclDatastore, 
            sbActionRepository,
            actionName, 
            label, 
            icon
        );

        if(!angular.isDefined(permissions)){
            let action;
            try {
                action = sbActionRepository.getAction(actionName);
            }
            catch(e){}
            permissions = action ? action.permissions : null;
        }
        
        item.permissions = permissions;
        
        return item;
    }
}


// WEBPACK FOOTER //
// ./src/sharebase-app/factories/deferredpermissionMenuItemFactory.ts